import React from 'react';
import { Checkbox } from 'antd';

import CheckboxField from 'components/Fields/Checkbox';
import styles from '../controls.module.scss';

export const MultipleControlList = ({ name, label: FieldLabel, items, required }) => (
  <CheckboxField
    model={`.${name}`}
    errorMessages={required ? { required: { message: 'Veuillez choisir une ou plusieurs réponses' } } : undefined}
    label={FieldLabel}
    type="checkbox"
    options={items.map(item => ({ label: item, value: item }))}
    className={styles.checkboxList}
    renderItem={({ value, label }) => (
      <label key={`${name}${value}`}>
        <Checkbox value={value} />
        {label}
      </label>
    )}
  />
);

export default MultipleControlList;



// WEBPACK FOOTER //
// ./src/components/Form/FormActivity/Controls/ControlList/MultipleControlList.js